import Login from "modules/auth/login/page/login";
import MainDashboard from "modules/main_dashboard/pages/MainDashboard";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainLayout from "layout/MainLayout";
import { PageNotFound } from "components";
import Packages from "modules/membership_plan/commercial_membership_plan/packages/Packages";
import Modules from "modules/modules/pages/Modules";
import Profile from "modules/profile/Profile";
import Category from "modules/video/category/Category";
import Episodes from "modules/video/episode/Episodes";
import Season from "modules/video/season/Season";
import Series from "modules/video/series/Series";
import VideoDetail from "modules/video/video_detail/VideoDetail";
import Group from "modules/video/group/Group";
import Coupon from "modules/cupon/Cupon";
import FAQ from "modules/faq/FAQ";
import DcddMembership from "modules/user_management/dcdd_user/bulk_registration/BulkRegistration";
import Users from "modules/user_management/dcdd_user/users/Users";
import Role from "modules/auth/role/Role";
import User from "modules/auth/users/pages/User";
import DcddMembershipPlan from "modules/membership_plan/dcdd_membership_plan/dcdd_membership/DcddMembershipPlan";
import CommercialUser from "modules/user_management/commercial_user/user/CommercialUser";
import PreviewCommercialProfile from "modules/user_management/commercial_user/user/page/PreviewCommercialProfile";
import CommercialMembership from "modules/membership_plan/commercial_membership_plan/commercial_membership/CommercialMembership";
import CreateMembershipPlan from "modules/membership_plan/commercial_membership_plan/create_membership_plan/CreateMembershipPlan";
import RmaPaymentTable from "modules/report/payment_responses/page/RmaPaymentTable";
import StripePaymentTable from "modules/report/payment_responses/page/StripePaymentTable";
import VideoViewCount from "modules/report/video_view_count/VideoViewCount";
import NewRegisterUsers from "modules/report/new_registered_users/commercial_user/NewRegistered";
import NewRegisterDcddUser from "modules/report/new_registered_users/dcdd_user/NewRegisterDcddUser";
import DcddActiveUserReport from "modules/report/active_user/dcdd/DcddActiveUser";
import CommercialActiveUserReport from "modules/report/active_user/commercial/CommercialActiveUser";
import EmailLogs from "modules/email_log/EmailLogs";
import Permission from "modules/auth/permission/Permission";
import DcddUserProfile from "modules/user_management/dcdd_user/users/page/DcddSingleUserProfile";
import FeaturedAds from "modules/featured_ads/FeaturedAds";
import ProtectedRoute from "utils/helpers/protectedRoute";
import DcddReport from "modules/report/dcdd_report/DcddReport";
import ComercialReport from "modules/report/commercial_report/CommercialRport";
import Avatar from "modules/avater/Avatar";
import CheyChey from "modules/chey_chey/CheyChey";
import SpecialOffer from "modules/special_offer/SpecialOffer";
import InAppPurchaseTable from "modules/report/payment_responses/page/InAppPurchaseTable";

const AppRoutes: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="*" element={<PageNotFound />} />
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route element={<MainLayout />}>
          {/* user */}
          <Route path="/system_setup/user" element={
                        <ProtectedRoute>
                            <User />
                        </ProtectedRoute>
          } />
          {/* role */}
          <Route path="/system_setup/role" element={ <ProtectedRoute><Role /></ProtectedRoute>} />
          <Route path="/system_setup/module" element={<ProtectedRoute><Modules /></ProtectedRoute>} />
          {/* permission */}
            <Route path="/system_setup/permisson" element={<ProtectedRoute><Permission /></ProtectedRoute>} />
          {/* dashboard */}
          <Route path="/main-dashboard" element={<ProtectedRoute><MainDashboard /></ProtectedRoute>} />
          {/* profile */}
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          {/* membership plan */}
          <Route path="/membership_plan/packages" element={<ProtectedRoute><Packages /></ProtectedRoute>} />
          <Route path="/membership_plan/commercial_membership" element={<ProtectedRoute><CommercialMembership /></ProtectedRoute>} />
          <Route path="/membership_plan/create_membership_plan" element={<ProtectedRoute><CreateMembershipPlan /></ProtectedRoute>} />
          <Route path="/membership_plan/dcdd_membership" element={<ProtectedRoute><DcddMembershipPlan /></ProtectedRoute>} />
          {/* Coupon */}
          <Route path="/membership_plan/coupon" element={<ProtectedRoute><Coupon /></ProtectedRoute>} />
          {/* FAQ */}
          <Route path="/faq" element={<ProtectedRoute><FAQ /></ProtectedRoute>} />
          {/* Featured Ads */}
          <Route path="/featured_ads" element={<ProtectedRoute><FeaturedAds /></ProtectedRoute>} />
          {/* dcdd User Management */}
          <Route path="/user_mamagement/dcdd_user/users" element={<ProtectedRoute><Users /></ProtectedRoute>} />
          <Route path="/user_mamagement/dcdd_user/bulk_registration" element={<ProtectedRoute>< DcddMembership /></ProtectedRoute>} />
          <Route path="/user_mamagement/registered_users/:userId" element={<ProtectedRoute><DcddUserProfile /></ProtectedRoute>} />
          {/*commercial user management*/}
          <Route path="/user_mamagement/commercial_user/users" element={<ProtectedRoute><CommercialUser /></ProtectedRoute>} />
          <Route path="/user_mamagement/commercial_user/user/:userId" element={<ProtectedRoute><PreviewCommercialProfile /></ProtectedRoute>} />
          {/* videos */}
          <Route path="/video" element={<ProtectedRoute><Group /></ProtectedRoute>} />
          <Route path="/video/:groupId" element={<ProtectedRoute><Category /></ProtectedRoute>} />
          <Route path="/video/:groupId/:categoryId" element={<ProtectedRoute><Series /></ProtectedRoute>} />
          <Route
            path="/video/:groupId/:categoryId/:seriesId"
            element={<ProtectedRoute><Season /></ProtectedRoute>}
          />
          <Route
            path="/video/:groupId/:categoryId/:seriesId/:seasonId"
            element={<ProtectedRoute><Episodes /></ProtectedRoute>}
          />
          <Route
            path="/video/:groupId/:categoryId/:seriesId/:seasonId/:episodeId"
            element={<ProtectedRoute><VideoDetail /></ProtectedRoute>}
          />
          {/* report */}
           <Route path="/report/rma_payment" element={<ProtectedRoute><RmaPaymentTable /></ProtectedRoute>} />
           <Route path="/report/stripe_payment" element={<ProtectedRoute><StripePaymentTable /></ProtectedRoute>} />
           <Route path="/report/in_app_payment" element={<ProtectedRoute><InAppPurchaseTable /></ProtectedRoute>} />
           <Route path="/report/video_view_count" element={<ProtectedRoute><VideoViewCount /></ProtectedRoute>} />
           <Route path="/report/dcdd_report" element={<ProtectedRoute><DcddReport /></ProtectedRoute>} />
           <Route path="/report/commercial_report" element={<ProtectedRoute><ComercialReport /></ProtectedRoute>} />
           <Route path="/report/new_register/commercial_user" element={<ProtectedRoute><NewRegisterUsers /></ProtectedRoute>} />
           <Route path="/report/new_register/dcdd_user" element={<ProtectedRoute><NewRegisterDcddUser /></ProtectedRoute>} />
           <Route path="/report/active_user/dcdd_user" element={<ProtectedRoute><DcddActiveUserReport /></ProtectedRoute>} />
           <Route path="/report/active_user/commercial_user" element={<ProtectedRoute><CommercialActiveUserReport /></ProtectedRoute>} />
           <Route path="/report/email_log" element={<ProtectedRoute><EmailLogs /></ProtectedRoute>} />
           <Route path="/avatar" element={<ProtectedRoute><Avatar/></ProtectedRoute>} />
           <Route path="/cheychey" element={<ProtectedRoute><CheyChey/></ProtectedRoute>} />
           <Route path="/special-offer" element={<ProtectedRoute><SpecialOffer/></ProtectedRoute>} />
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRoutes;
